import React, { Component } from 'react';
import { roles } from '../../../util/Roles';
import { sanitizerTexto } from '../../../util/utilerias';
import { get_id } from '../../../util/IdUser';
import { openNotification } from '../../../util/notificaciones';
import moment from 'moment';
import CatalogoRequest from '../../../services/Catalogo';
import InventarioRequest from '../../../services/Inventario';
import ReportDtlViews from './ReportDtlViews';
import { Spin, Table, Tooltip, Button, Card, Icon, InputNumber, Col, Row, Modal, Select, Pagination } from 'antd';
import { esBarras, getSegmento } from '../../../util/generics';
import InventarioBarrasRequest from '../../../services/InventarioBarras';
moment.locale('es')
const rol = localStorage.getItem("role")?.split(",");
const { Option } = Select

/**
 * Evento para cancelar el scroll en input number
 */
document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

/**
 * Clase para ver el proceso de mostrar artículos del inventario
 */
export default class ReportViews extends Component {
    state = {
        esBarra: esBarras(),
        arrListaInventario: [],
        filterText: "",
        cargando: false,
        arrDrives: [],
        driveSelected: undefined,
        scroll: { x: 1050, y: 500 },
        disable_combo_drive: false,
        mostrar_modal_articulos: false,
        arr_articulos_error: [],
        mostrar_variacion: false,
        paginacion: {},
        pageSize: 100,
        totalArticulos: 0,
        FechaStr: ""
    }

    /**
     * Comportamiento del componente al mostrar los artículos
     */
    componentDidMount = () => {
        let state = { ...this.state };
        const segmento = getSegmento()

        if (!segmento) {
            const location = {
                pathname: "/",
            }
            this.setState(state, this.props.history.push(location))
        } else {
            const script = document.createElement("script");
            script.src = "https://kit.fontawesome.com/a076d05399.js";
            script.async = true;
            script.crossorigin = 'anonymous';
            document.body.appendChild(script);

            CatalogoRequest.CargarSitiosByUsuario(get_id()).then(response => {
                state.arrDrives = response.data
                state.FechaStr = new Date().toLocaleDateString();
                this.setState(state, () => {
                    if (response.data.length === 1) {
                        this.setState({ driveSelected: response.data[0].id }, this.onChangeDrive)
                    } else {
                        let elSitio = response.data.find((item) => item.id == (this.props.match.params.idSitio * 1));
                        if (elSitio != undefined) {
                            this.setState({ driveSelected: (this.props.match.params.idSitio * 1) }, this.onChangeDrive);
                        }
                    }
                    if (!response.data.length) {
                        if (rol.includes(roles.Operador)) {
                            const error = state.esBarra
                                ? "El usuario no tiene asignada una barra, favor de contactar al Administrador."
                                : "El usuario no tiene asignado un punto de venta, favor de contactar al Administrador."
                            openNotification(
                                error,
                                "Error"
                            )
                        } else {
                            const aviso = state.esBarra
                                ? "El usuario no tiene asignada una barra, deberá configurarlo en el módulo de usuarios."
                                : "El usuario no tiene asignado un punto de venta, deberá configurarlo en el módulo de usuarios."
                            openNotification(
                                aviso,
                                "Aviso"
                            )
                        }
                    }
                })
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al listar los puntos de venta del usuario.",
                    "Error"
                )
            })
        }
    }

    /**
     * Se ejecuta cuando se cambia un drive
     */
    onChangeDrive = () => {
        let state = { ...this.state };
        this.setState({ cargando: true }, () => {
            if (state.driveSelected) {
                const request = state.esBarra ? InventarioBarrasRequest : InventarioRequest
                request.ListarInventarioPT(state.driveSelected, this.props.match.params.esExterno).then(response => {
                    state.paginacion = {
                        current: 1,
                        total: response.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 100,
                        showTitle: false
                    }

                    state.cargando = false;
                    let toDay = new Date();
                    let today = new Date().toLocaleDateString();
                    response.data.results.find((item) => {
                        let toDy = new Date(item.Fecha);
                        toDy.setHours(toDy.getHours() + 7);
                        item.Fecha2 = new Date(item.Fecha);
                        item.Fecha2.setHours(item.Fecha2.getHours() + 7);
                        item.FechaStr = `${toDy.getFullYear()}-${(toDy.getMonth() + 1).toString().padStart(2, '0')}-${toDy.getDate().toString().padStart(2, '0')}`;
                        item.FechaStr2 = `${toDy.getDate().toString().padStart(2, '0')}/${(toDy.getMonth() + 1).toString().padStart(2, '0')}/${toDy.getFullYear()}`;
                        //item.FechaStr = toDy.toLocaleDateString();
                    });
                    state.arrListaInventario = response.data.results.filter((item) => item.Estatus == 5);
                    state.disableRange = false;
                    this.setState(state)
                }).catch(err => {
                    this.setState({ cargando: false });
                    openNotification(
                        "Ha ocurrido un error al listar el histórico del drive seleccionado.",
                        "Error"
                    )
                })
            } else {
                state.cargando = false;
                state.paginacion.total = 0;
                state.arrListaInventario = [];
                state.disableRange = true;
                state.dateStrings = [];
                state.fecha_historico = [];
                this.setState(state)
            }
        })
    }

    showForm = (type, _, record) => {
        this.setState({ typeForm: type, objInventario: record, visible: true })
    }

    esconderModal = (value) => {
        let state = { ...this.state }
        state.visible = false;
        state.visibleSAP = false;
        state.objInventario = null;
        this.setState(state, () => {
            if (value) this.onChangeDrive()
        })
    }

    currencyFormat(num) {
        return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    render() {
        const columnasInventario = [
            {
                title: "Fecha (dd/mm/aaaa)",
                dataIndex: "Fecha2",
                key: "Fecha2",
                render: fecha => { return (<span> {moment(new Date(fecha)).format("DD/MM/YYYY")} </span>) }
            },
            !this.state.esBarra && {
                title: "Centro SAP",
                dataIndex: "centroSAP",
                key: "centroSAP",
                render: centroSAP => { return (<span> {centroSAP} </span>) }
            },
            {
                title: "Usuario que capturó",
                dataIndex: "usuario",
                key: "usuario",
                render: usuario => { return (<span> {usuario} </span>) }
            },
            !this.state.esBarra && {
                title: "Inventario Número",
                dataIndex: "Refencia",
                key: "Refencia",
                render: Refencia => { return (<span> {Refencia} </span>) }
            },
            {
                title: 'Sobrante',
                dataIndex: 'Sobrante',
                key: 'Sobrante',
                width: 130,
                render: Sobrante => (<div>{this.currencyFormat(Sobrante)}</div>)
            },
            {
                title: 'Faltante',
                dataIndex: 'Faltante',
                key: 'Faltante',
                width: 130,
                render: Faltante => (<div>{this.currencyFormat(Faltante)}</div>)
            },
            {
                title: 'Neto',
                dataIndex: 'Diferencia',
                key: 'Diferencia',
                width: 130,
                render: (value, record) => (<div>{this.currencyFormat(record.Sobrante - record.Faltante)}</div>)
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div style={{ textAlign: "center" }}>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Ver detalle de inventario"}>
                                <Button icon="eye" className="btnVerCrearGuardar" onClick={() => this.showForm('detalle', value, record)}></Button>
                            </Tooltip>
                        </span>
                    </div>
                )
            }
        ].filter(Boolean)

        return (
            <Card id="ParentSize" title={'Diferencia de inventarios'} >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={24}>
                            <Col lg={8} md={10}>
                                <Tooltip placement="top" title={this.state.esBarra ? "Barra" : "Punto de venta"}>
                                    <div className="center">
                                        {
                                            this.state.esBarra
                                                ? "Barra:"
                                                : "Punto de venta:"
                                        }
                                    </div>
                                    <Select
                                        defaultActiveFirstOption={false}
                                        allowClear={this.state.arrDrives?.length > 1}
                                        showSearch
                                        disabled={this.state.disable_combo_drive}
                                        notFoundContent={"No hay opciones"}
                                        style={{ width: "100%" }}
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        filterOption={(input, option) => sanitizerTexto(input, option.props.children)}
                                        value={this.state.driveSelected}
                                        onChange={(value) => {
                                            this.setState({ driveSelected: value }, this.onChangeDrive)
                                        }}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrDrives?.length > 0 &&
                                            this.state.arrDrives.map((obj, index) => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>
                    {<Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(_, index) => index}
                            columns={columnasInventario}
                            dataSource={this.state.arrListaInventario}
                            pagination={this.state.paginacion}
                        />
                    </Spin>}
                </div>
                <ReportDtlViews
                    esconderModal={this.esconderModal}
                    visible={this.state.visible}
                    type={this.state.typeForm}
                    inventario={this.state.objInventario}
                    drive_selected={this.state.driveSelected}
                    esExterno={this.props.match.params.esExterno}
                />
            </Card>
        )
    }
}